export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const stripTestimonials: Testimonial[] = [
  {
    initials: 'AC',
    name: 'Alessandra Conti',
    role: 'Docente universitaria — Italia',
    text: 'INSERISCI QUI UNA TESTIMONIANZA REALE DI UN DOCENTE.',
  },
  {
    initials: 'SB',
    name: 'Stefano Bruni',
    role: 'Docente di metodologia — Italia',
    text: 'INSERISCI QUI UNA SECONDA TESTIMONIANZA REALE.',
  },
  {
    initials: 'MR',
    name: 'Martina Rossi',
    role: 'Docente universitaria — Italia',
    text: 'INSERISCI QUI UNA TERZA TESTIMONIANZA REALE.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'PG',
    name: 'Paolo Gentile',
    role: 'Docente di Metodologia | Italia',
    text: 'INSERISCI QUI UNA TESTIMONIANZA REALE RELATIVA AI VOLUMI PRINCIPALI.',
  },
  {
    initials: 'VM',
    name: 'Valentina Marchetti',
    role: 'Docente universitaria | Italia',
    text: 'INSERISCI QUI UNA TESTIMONIANZA REALE RELATIVA ALLE ATTIVITÀ O AI BONUS.',
  },
  {
    initials: 'RE',
    name: 'Riccardo Esposito',
    role: 'Docente di ricerca | Italia',
    text: 'INSERISCI QUI UNA TESTIMONIANZA REALE RELATIVA AL RISPARMIO DI TEMPO.',
  },
  {
    initials: 'FC',
    name: 'Francesca Colombo',
    role: 'Docente universitaria | Italia',
    text: 'INSERISCI QUI UNA TESTIMONIANZA REALE RELATIVA ALLA CHIAREZZA DEL MATERIALE.',
  },
  {
    initials: 'DB',
    name: 'Davide Barbieri',
    role: 'Professore di metodologia | Italia',
    text: 'INSERISCI QUI UNA TESTIMONIANZA REALE RELATIVA ALLA SICUREZZA IN AULA.',
  },
]
